import React, { useContext, useEffect, useState } from 'react';
import './RelatedProducts.css';
import { ShopContext } from '../../Context/ShopContext';
import Item from '../Item/Item';

const RelatedProducts = () => {
  const { all_product } = useContext(ShopContext); // استخدام بيانات السيرفر
  const [relatedProducts, setRelatedProducts] = useState([]);

  useEffect(() => {
    // مثال: جلب منتجات متعلقة (يمكن تعدل الشرط حسب الحاجة)
    if (all_product.length > 0) {
      setRelatedProducts(all_product.slice(0, 4)); // جلب 4 منتجات كمثال
    }
  }, [all_product]);

  return (
    <div className='relatedproducts'>
      <h1>Related Products</h1>
      <hr />
      <div className='relatedproducts-item'>
        {relatedProducts.map((item, i) => (
          <Item
            key={i}
            id={item.id}
            name={item.name}
            image={item.image_urls?.[0] || item.image || 'https://via.placeholder.com/300'}
            new_price={item.new_price}
            old_price={item.old_price}
          />
        ))}
      </div>
    </div>
  );
};

export default RelatedProducts;